import { MessagePageProps } from './types';
import { StyledMessagePage } from './style';
import { useEffect, useState } from 'react';
import { checkIfOlderOsVersions } from '../Helper/utils/utils';

function MessagePage({
    headerText,
    headerColor,
    headerSize,
    headerWeight,
    text,
    textColor,
    textSize,
    fontFamily,
    textWeight,
    children,
    preview = false,
    flex,
    dataTestId = {header: '', line: ''}
}: MessagePageProps) {
    const [addedClasses, setAddedClasses] = useState<string>('');

    useEffect(() => {
        if (checkIfOlderOsVersions()) {
            setAddedClasses('container--ios13');
        }
    }, []);

    return (
        <StyledMessagePage
            fontFamily={fontFamily}
            headerColors={headerColor}
            preview={preview}
            textWeight={textWeight}
            headerWeight={headerWeight}
            textColor={textColor}
            flex={flex}
        >
            <div className={`container ${addedClasses}`}>
                <h1
                    style={{
                        fontSize: `${headerSize}px`,
                        fontWeight: `${headerWeight}`
                    }}
                    data-testid={dataTestId.header}
                >
                    {headerText}
                </h1>
                {text.map((line, i) => (
                    <h2 key={i} style={{ fontSize: `${textSize}px` }} data-testid={dataTestId.line}>
                        {line}
                    </h2>
                ))}
                {children}
            </div>
        </StyledMessagePage>
    );
}

export default MessagePage;
